import React from 'react';

export function RepeatPlay(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.36609 9.07251C4.18097 9.88705 5.28592 10.3447 6.43809 10.3449C8.82154 10.3449 10.7829 8.38355 10.7829 6.0001C10.7829 3.61665 8.82195 1.65527 6.43809 1.65527C4.05423 1.65527 2.09326 3.61665 2.09326 6.0001"
        stroke="#525866"
        stroke-miterlimit="10"
      />
      <path
        d="M5.10327 7.39719V4.60284C5.10335 4.55431 5.11626 4.50667 5.1407 4.46474C5.16514 4.42281 5.20022 4.38809 5.24241 4.3641C5.28459 4.34011 5.33237 4.3277 5.38089 4.32814C5.42942 4.32857 5.47697 4.34183 5.51872 4.36656L7.86575 5.76353C7.90665 5.78789 7.94052 5.82245 7.96404 5.86383C7.98756 5.90521 7.99993 5.952 7.99993 5.9996C7.99993 6.0472 7.98756 6.09398 7.96404 6.13537C7.94052 6.17675 7.90665 6.21131 7.86575 6.23567L5.51872 7.63263C5.47708 7.65761 5.42955 7.67108 5.38099 7.67168C5.33244 7.67228 5.28459 7.65998 5.24235 7.63604C5.2001 7.61209 5.16497 7.57737 5.14053 7.5354C5.1161 7.49344 5.10324 7.44574 5.10327 7.39719Z"
        fill="#525866"
      />
      <path d="M1.21704 4.63525L1.95194 5.95939L3.27608 5.2245" stroke="#525866" stroke-miterlimit="10" />
    </svg>
  );
}
